//Le but ici est de calculer les faits de jeu necessaires pour matcher au score saisi

import { GAME_FACT_BASKET_FREETHROW, GAME_FACT_BASKET_THREEPOINTS, GAME_FACT_BASKET_TWOPOINTS, GAME_FACT_DROP, GAME_FACT_ESSAI, GAME_FACT_PENALITE, GAME_FACT_SOCCER_BUT, GAME_FACT_TRANSFORMATION, GAME_FACT_HANDBALL_GOAL, GAME_FACT_HANDBALL_PENALTY, GAME_FACT_HANDBALL_SHOOTOUT } from "../gameFact/constants.js"


export const getScoreTypes = (discipline) => {
    switch(discipline){
        case 'soccer':
            return [GAME_FACT_SOCCER_BUT]
        case 'rugby':
            return [GAME_FACT_ESSAI, GAME_FACT_TRANSFORMATION, GAME_FACT_DROP, GAME_FACT_PENALITE]
        case 'basket':
            return [GAME_FACT_BASKET_FREETHROW, GAME_FACT_BASKET_TWOPOINTS, GAME_FACT_BASKET_THREEPOINTS]
        case 'handball':
            return [GAME_FACT_HANDBALL_GOAL, GAME_FACT_HANDBALL_PENALTY]
        default:
            return []
    }
}


export const autoScore = (discipline, team, value = 0, subValue = 0) => {

    switch(discipline){
        case 'soccer' :
            return getSoccerGameFacts(team, value)
        case 'rugby' :
            return getRugbyGameFacts(team, value, subValue)
        case 'basket' :
            return getBasketGameFacts(team, value)
        case 'handball' :
            return getHandballGameFacts(team, value)
        default :
            return []
    }
}

const createGameFact = (team, title, text, type) => ({
    gameFactDetail: {
        butSucced: 1,
        buteur: null,
        edited: true,
        passeur: null,
        period: 0,
        team: team._id,
        title: title,
        text: text + team.name + "!",
        timer: 0,
    },
    count: 0, // La valeur sera ajustée en fonction du score
    type: type
});


const getSoccerGameFacts = (team, value) => {

    // Fait de jeu but
    const type = GAME_FACT_SOCCER_BUT
    const gameFactDetail = {
        butSucced: 1,
        buteur: null,
        edited: true,
        passeur: null,
        period: 0,
        team : team._id,
        title : "BUT",
        text : "But de "+team.name+"!",
        timer: 0,
    }

    return [{gameFactDetail, count : value, type}]
}

const getBasketGameFacts = (team, value) => {

    let nbTwos = 0;
    let nbThrees = 0;

    // Trouver les valeurs de nbTwos et nbThrees
    while (nbThrees * 3 <= value) {
        const remainder = value - nbThrees * 3;
        if (remainder % 2 === 0) {
            nbTwos = remainder / 2;
            break;
        }
        nbThrees++;
    }

    // Fait de jeu 2 points
    const twosType = GAME_FACT_BASKET_TWOPOINTS
    const gameFactTwosDetail = {
        player: null,
        edited: true,
        period: 0,
        isSucceed:1,
        team : team._id,
        title : "DEUX POINTS",
        text : "Deux points de "+team.name+"!",
        timer: 0,
    }

    const twos = {gameFactDetail : gameFactTwosDetail, count : nbTwos, type : twosType}

    // Fait de jeu 3 points
    const threesType = GAME_FACT_BASKET_THREEPOINTS
    const gameFactThreesDetail = {
        player: null,
        edited: true,
        period: 0,
        isSucceed:1,
        team : team._id,
        title : "TROIS POINTS",
        text : "Trois points de "+team.name+"!",
        timer: 0,
    }

    const threes = {gameFactDetail : gameFactThreesDetail, count : nbThrees, type : threesType}

    return [{...twos}, {...threes}]
}

const getRugbyGameFacts = (team, value, subValue) => {


    let nbEssai = subValue;

    let nbTransformation = 0;
    let nbDrop = 0;

    // Trouver les valeurs de nbTransformation et nbDrop
    while (nbTransformation * 2 + nbDrop * 3 <= value - nbEssai * 5) {
        const remainder = value - nbTransformation * 2 - nbEssai * 5;
        if (remainder % 3 === 0) {
            nbDrop = remainder / 3;
            break;
        }
        nbTransformation++;
    }

    // Fait de jeu essai
    const essaiType = GAME_FACT_ESSAI
    const gameFactEssaiDetail = {
        buteur: null,
        edited: false,
        period: 0,
        team : team._id,
        title : "ESSAI",
        text : "Essai de "+team.name+"!",
        timer: 0,
    }

    const essais = {gameFactDetail : gameFactEssaiDetail, count : nbEssai, type : essaiType}

    // Fait de jeu transformation
    const transformationType = GAME_FACT_TRANSFORMATION
    const gameFactTransformationDetail = {
        transformSucced : 1,
        transformer: null,
        edited: false,
        period: 0,
        team : team._id,
        title : "TRANSFORMATION",
        text : "Transformation réussie par "+team.name+"!",
        timer: 0,
    }

    const transformations = {gameFactDetail : gameFactTransformationDetail, count : nbTransformation, type : transformationType}

    // Fait de jeu drop
    const dropType = GAME_FACT_DROP
    const gameFactDropDetail = {
        dropSucced : 1,
        droper: null,
        edited: false,
        period: 0,
        team : team._id,
        title : "DROP",
        text : "Penalité réussie par "+team.name+"!",
        timer: 0,
    }

    const drops = {gameFactDetail : gameFactDropDetail, count : nbDrop, type : dropType}
    
    return [{...essais}, {...transformations}, {...drops}]
}

const getHandballGameFacts = (team, value) => {
    // Calc theorical number of GF based on score value
    //let calcValue = Math.max(1, value / 2);
    let calcValue = value;

    // Init GF
    let goals = createGameFact(team, "BUT", "But de ", GAME_FACT_HANDBALL_GOAL);
    //let penalties = createGameFact(team, "PENALTY", "Penalty de ", GAME_FACT_HANDBALL_PENALTY);

    // Adjust nb with score value & count penalties only if score >1
    goals.count = calcValue;
   // penalties.count = value > 1 ? calcValue : 0;

    //return value > 0 ? [goals, ...(value > 1 ? [penalties] : [])] : [];
    return [goals]
};